import Axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import ApiConfig from "../../config/ApiConfig";
import PageTitle from "../../components/PageTitle/PageTitle";
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import CircularProgressWithBackdrop from "../../components/Loader/loader";
import { DropzoneArea } from "material-ui-dropzone";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { UserContext } from "../../context/User";
import { Delete } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: theme.spacing(3),
  },
  formContainer: {
    background: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
    padding: theme.spacing(4),
    border: "1px solid #e0e0e0",
  },
  sectionTitle: {
    fontSize: "1.5rem",
    fontWeight: "600",
    color: "#2c3e50",
    marginBottom: theme.spacing(3),
    paddingBottom: theme.spacing(1),
    borderBottom: "2px solid #00d4ff",
  },
  TextBox: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00d4ff",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00d4ff",
        borderWidth: "2px",
      },
    },
  },
  label: {
    fontWeight: "600",
    fontSize: "0.95rem",
    color: "#34495e",
    marginBottom: theme.spacing(1),
    display: "block",
  },
  select: {
    "& .MuiOutlinedInput-root": {
      height: "48px",
      borderRadius: "8px",
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00d4ff",
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00d4ff",
        borderWidth: "2px",
      },
    },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      padding: "12px 14px",
    },
  },
  date: {
    color: "#e74c3c",
    fontSize: "0.875rem",
    marginTop: theme.spacing(0.5),
  },
  btn: {
    minWidth: "120px",
    height: "44px",
    background: "linear-gradient(135deg, #00d4ff 0%, #0099cc 100%)",
    color: "white",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: "600",
    fontSize: "0.95rem",
    boxShadow: "0 2px 8px rgba(0, 212, 255, 0.3)",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "linear-gradient(135deg, #0099cc 0%, #007aa3 100%)",
      boxShadow: "0 4px 12px rgba(0, 212, 255, 0.4)",
      transform: "translateY(-1px)",
    },
  },
  uploadSection: {
    background: "#f8f9fa",
    borderRadius: "12px",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    border: "2px dashed #dee2e6",
    transition: "all 0.3s ease",
    "&:hover": {
      borderColor: "#00d4ff",
      background: "#f0fdff",
    },
  },
  uploadTitle: {
    fontSize: "1.25rem",
    fontWeight: "600",
    color: "#2c3e50",
    marginBottom: theme.spacing(2),
    textAlign: "center",
  },
  uploadGrid: {
    marginTop: theme.spacing(2),
  },
  videoContainer: {
    position: "relative",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  imageContainer: {
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  colorbox1: {
    width: "100%",
    "& .MuiGrid-container": {
      display: "block !important",
    },
    "& .MuiGrid-grid-xs-4": {
      maxWidth: "100%",
    },
    "& .MuiDropzoneArea-textContainer": {
      display: "none",
    },
    "& .MuiDropzonePreviewList-image": {
      height: "100%",
      maxHeight: "200px",
      borderRadius: "8px",
    },
    "& .MuiDropzonePreviewList-removeButton": {
      display: "block",
      top: "8px",
      right: "8px",
      width: "32px",
      height: "32px",
      opacity: 0.8,
      position: "absolute",
      transition: "opacity 0.3s ease",
      background: "rgba(255, 255, 255, 0.9)",
      borderRadius: "50%",
      "&:hover": {
        opacity: 1,
        background: "rgba(255, 255, 255, 1)",
      },
    },
    "& .MuiDropzoneArea-root": {
      border: "2px dashed #dee2e6",
      borderRadius: "8px",
      background: "#f8f9fa",
      transition: "all 0.3s ease",
      "&:hover": {
        borderColor: "#00d4ff",
        background: "#f0fdff",
      },
    },
  },
  colorbox: {
    width: "100%",
    "& .MuiGrid-container": {
      display: "block !important",
    },
    "& .MuiGrid-grid-xs-4": {
      maxWidth: "100%",
    },
    "& .MuiDropzoneArea-textContainer": {
      display: "block !important",
    },
    "& .MuiDropzonePreviewList-removeButton": {
      display: "block",
      top: "8px",
      right: "8px",
      width: "32px",
      height: "32px",
      opacity: 0.8,
      position: "absolute",
      transition: "opacity 0.3s ease",
      background: "rgba(255, 255, 255, 0.9)",
      borderRadius: "50%",
      "&:hover": {
        opacity: 1,
        background: "rgba(255, 255, 255, 1)",
      },
    },
    "& .MuiDropzoneArea-root": {
      border: "2px dashed #dee2e6",
      borderRadius: "8px",
      background: "#f8f9fa",
      transition: "all 0.3s ease",
      "&:hover": {
        borderColor: "#00d4ff",
        background: "#f0fdff",
      },
    },
  },
  deleteBTN: {
    position: "absolute",
    top: "8px",
    right: "8px",
    zIndex: 100,
    background: "rgba(255, 255, 255, 0.9)",
    opacity: 0.8,
    transition: "all 0.3s ease",
    borderRadius: "50%",
    width: "32px",
    height: "32px",
    "&:hover": {
      opacity: 1,
      background: "rgba(255, 255, 255, 1)",
      transform: "scale(1.1)",
    },
  },
  formSection: {
    marginBottom: theme.spacing(4),
  },
  resultSection: {
    background: "#f8f9fa",
    borderRadius: "12px",
    padding: theme.spacing(3),
    marginTop: theme.spacing(2),
  },
  resultValueDisplay: {
    fontWeight: "600",
    padding: "12px 16px",
    border: "2px solid #e0e0e0",
    borderRadius: "8px",
    background: "#ffffff",
    color: "#2c3e50",
    textAlign: "center",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    gap: theme.spacing(2),
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(3),
    borderTop: "1px solid #e0e0e0",
  },
  uploadButtonContainer: {
    textAlign: "center",
    marginTop: theme.spacing(2),
  },
  uploadedStatus: {
    color: "#27ae60",
    fontWeight: "600",
    fontSize: "1rem",
  },
  currentFilesSection: {
    background: "#e8f5e8",
    borderRadius: "8px",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    border: "1px solid #c8e6c9",
  },
  currentFilesTitle: {
    fontSize: "1rem",
    fontWeight: "600",
    color: "#2e7d32",
    marginBottom: theme.spacing(1),
  },
  fileInfo: {
    fontSize: "0.9rem",
    color: "#388e3c",
    marginBottom: theme.spacing(0.5),
  },
}));

function UpdateTest(props) {
  const ContextId = useContext(UserContext);
  const history = useHistory();
  const [additionalResultFields, setAdditionalResultFields] = useState([]);
  const classes = useStyles();
  const [viewTest, setViewDetails] = useState();
  const [testId, setTestId] = useState(ContextId.id);
  const [link, setLink] = useState(null);
  const [result, setResult] = useState([]);
  const [value, setValue] = useState("QUALITATIVE");
  const [testIMG, setTestIMG] = useState(null);
  const [profileImage, setProfileImage] = useState("");
  const [loader, setLoader] = useState(false);

  const [formData, setFormData] = useState({
    testName: "",
    unit: "",
    incubation: "",
    expirationTime: "",
    positiveValue: "",
    positiveColorCode: "",
    negativeValue: "",
    negativeColorCode: "",
    acceptedResultValue: "",
    resultColorCode: "",
  });
  const [incubationType, setIncubationType] = useState("SEC");
  const [expirationType, setExpirationType] = useState("SEC");

  const handleVideoChange = (files) => {
    const file = files[0];
    if (file) {
      getVideoDuration(file)
        .then((duration) => {
          if (duration <= 90) {
            return getBase64Data(file);
          } else {
            toast.error("Video duration exceeds 90 seconds.");
            throw new Error("Video duration exceeds 30 seconds.");
          }
        })
        .then((base64) => {
          setViewDetails(base64);
        })
        .catch((error) => {
          console.error("Error handling video:", error);
        });
    }
  };

  const getVideoDuration = (file) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = function () {
        resolve(video.duration);
      };
      video.onerror = (error) => {
        reject(error);
      };
      video.src = URL.createObjectURL(file);
    });
  };

  const getBase64Data = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleDrop = (files) => {
    if (files.length > 0) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setTestIMG(e.target.result);
      };
      reader.readAsDataURL(files[0]);
    }
  };

  const uploadIMG = async () => {
    if (!testIMG) {
      toast.error("No image selected");
      return;
    }
  
    setLoader(true);
    try {
      // Extract pure base64 data (remove data URI prefix if present)
      const base64Data = testIMG.includes(',') ? 
        testIMG.split(',')[1] : 
        testIMG.replace(/^data:image\/\w+;base64,/, '');
      
      const res = await Axios({
        method: "POST",
        url: ApiConfig.uploadImage,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
          'Content-Type': 'application/json'
        },
        data: [base64Data] // Send as array of pure base64 strings
      });
  
      if (res.data.status === 200) {
        setProfileImage(res.data.data[0]);
        toast.success("Image uploaded successfully");
      } else {
        toast.error(res.data.message || "Image upload failed");
      }
    } catch (error) {
      console.error("Image upload error:", error);
      toast.error(error.response?.data?.message || "Failed to upload image");
    } finally {
      setLoader(false);
    }
  };

 
  const AddVideoHandler = async () => {
    if (!viewTest) {
      toast.error("No video selected");
      return;
    }
  
    setLoader(true);
    try {
      // Extract pure base64 data (remove data URI prefix if present)
      const base64Data = viewTest.includes(',') ? 
        viewTest.split(',')[1] : 
        viewTest.replace(/^data:video\/\w+;base64,/, '');
      
      const res = await Axios({
        method: "POST",
        url: ApiConfig.uploadVideo,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
          'Content-Type': 'application/json'
        },
        params: {  // Add fileType as a query parameter
          fileType: "VIDEO"
        },
        data: [base64Data] // Send as array of pure base64 strings
      });
  
      if (res.data.status === 200) {
        toast.success(res.data.message);
        setLink(res?.data?.data[0]);
      } else {
        toast.error(res.data.message || "Video upload failed");
      }
    } catch (error) {
      console.error("Video upload error:", error);
      toast.error(error.response?.data?.message || "Failed to upload video");
    } finally {
      setLoader(false);
    }
  };

  // const viewTestDetails = async () => {
  //   try {
  //     const res = await Axios({
  //       method: "GET",
  //       url: ApiConfig.viewTestAdmin,
  //       headers: {
  //         Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
  //       },
  //       params: {
  //         radomTestId: testId,
  //       },
  //     });

  //     if (res.data.status === 200) {
  //       setViewDetails(res?.data?.data?.testData.tutorialVideo);
  //       setResult(res?.data?.data?.expectedResults);
  //       setValue(res?.data?.data?.testData?.testResult);
  //       setAdditionalResultFields(res?.data?.data?.expectedResults);
  //       setTestIMG(res?.data?.data?.testData.testResultImage);
  //       setFormData({
  //         testName: res?.data?.data?.testData?.testName,
  //         unit: res?.data?.data?.testData?.unit,
  //         incubation: res?.data?.data?.testData?.incubationTime,
  //         expirationTime: res?.data?.data?.testData?.expirationTime,
  //         positiveColorCode: res?.data?.data?.expectedResults?.colorCode,
  //         negativeColorCode: res?.data?.data?.expectedResults?.colorCode,
  //       });
  //       setIncubationType(res?.data?.data?.testData?.data);
  //       setExpirationType(res?.data?.data?.testData?.expirationData);
  //     }
  //   } catch (error) {}
  // };

  const viewTestDetails = async () => {
  try {
    const res = await Axios({
      method: "GET",
      url: ApiConfig.viewTestAdmin,
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
      },
      params: {
        radomTestId: testId,
      },
    });

    console.log("FULL API RESPONSE:", res.data); // Debug log

    if (res.data.status === 200) {
      const responseData = res.data.data;
      const testData = responseData.testData;
      const expectedResults = responseData.expectedResults;

      // Set video and image
      setViewDetails(testData?.tutorialVideo);
      setTestIMG(testData?.testResultImage);

      // Set results and form data
      setResult(expectedResults);
      setValue(testData?.testResult || "QUALITATIVE");
      
      // Handle expectedResults - ensure it's always an array
      const formattedResults = Array.isArray(expectedResults) 
        ? expectedResults.map(result => ({
            resultValue: result.resultValue || "",
            colorCode: result.colorCode || ""
          }))
        : [];

      setAdditionalResultFields(formattedResults);

      // Set form data with proper fallbacks
      setFormData({
        testName: testData?.testName || "",
        unit: testData?.unit || "",
        incubation: testData?.incubationTime || "",
        expirationTime: testData?.expirationTime || "",
        positiveColorCode: expectedResults?.[0]?.colorCode || "",
        negativeColorCode: expectedResults?.[1]?.colorCode || "",
      });

      // Set time types with proper fallbacks
      setIncubationType(testData?.data || "SEC");
      setExpirationType(testData?.expirationData || "SEC");

      console.log("Processed data:", {
        testData,
        expectedResults: formattedResults,
        incubationType: testData?.data,
        expirationType: testData?.expirationData
      });
    }
  } catch (error) {
    console.error("Error fetching test details:", error);
    toast.error("Failed to load test details");
  }
};

  const updateTestDetails = async () => {
    console.log("Sending data to API:", {
    adminTestDto: {
      incubationTime: formData.incubation,
      data: incubationType,
      expirationData: expirationType,
      expirationTime: formData.expirationTime,
      testName: formData.testName,
      tutorialVideo: link || viewTest,
      unit: formData.unit,
      testResultImage: profileImage || testIMG,
    },
    expectedResultDtos: additionalResultFields,
  });
    try {
      const res = await Axios({
        method: "PUT",
        url: ApiConfig.updateTest,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
        },
        params: {
          randomTestId: testId,
        },
        data: {
          adminTestDto: {
            incubationTime: formData.incubation,
            data: incubationType, //time type
            expirationData: expirationType, //time type
            expirationTime: formData.expirationTime,
            testName: formData.testName,
            tutorialVideo: link || viewTest,
            unit: formData.unit,
            testResultImage: profileImage || testIMG,
          },
          expectedResultDtos: additionalResultFields,
        },
      });
    

      if (res.data.status === 200) {
        toast.success("Test Updated Successfully");
        history.push("/app/test-management");
      }
    } catch (error) {
      if (error.response.status === 500) {
        toast.error(error.response.error);
        history.push("/app/test-management");
      }
    }
  };
  useEffect(() => {
    viewTestDetails();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

const handleChange1 = (event, index, fieldType) => {
  const { value } = event.target;
  const updatedResultFields = [...additionalResultFields];
  
  updatedResultFields[index] = {
    ...updatedResultFields[index],
    [fieldType === "result" ? "resultValue" : "colorCode"]: value
  };
  
  setAdditionalResultFields(updatedResultFields);
};
  return (
    <>
      <PageTitle title="Update Test" />
      <div className={classes.container}>
        <div className={classes.formContainer}>
          {/* Test Name Section */}
          <div className={classes.formSection}>
            <Typography className={classes.sectionTitle}>Test Information</Typography>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <label className={classes.label}>
                  Test Name <span style={{ color: "red" }}>*</span>
                </label>
                <TextField
                  placeholder="Enter test name"
                  type="text"
                  variant="outlined"
                  fullWidth
                  id="testName"
                  size="small"
                  inputProps={{ maxLength: 255 }}
                  name="testName"
                  value={formData.testName}
                  onChange={(e) => handleChange(e)}
                  className={classes.TextBox}
                />
                <FormHelperText error className={classes.date}>
                  {/* {errors.testName} */}
                </FormHelperText>
              </Grid>
            </Grid>
          </div>

          {/* Current Files Section
          {(viewTest || testIMG) && (
            <div className={classes.currentFilesSection}>
              <Typography className={classes.currentFilesTitle}>
                Current Files
              </Typography>
              {viewTest && (
                <Typography className={classes.fileInfo}>
                  ✓ Video file is currently loaded
                </Typography>
              )}
              {testIMG && (
                <Typography className={classes.fileInfo}>
                  ✓ Image file is currently loaded
                </Typography>
              )}
            </div>
          )} */}

          {/* Upload Section */}
          <div className={classes.uploadSection}>
            <Typography className={classes.uploadTitle}>Update Video and Image</Typography>
            <Grid container spacing={3} className={classes.uploadGrid}>
              <Grid item xs={12} md={6}>
                <Typography className={classes.label} style={{ marginBottom: "8px" }}>
                  Test Video <span style={{ color: "red" }}>*</span>
                </Typography>
                {viewTest ? (
                  <div className={classes.videoContainer} style={{ position: "relative" }}>
                    <IconButton
                      className={classes.deleteBTN}
                      onClick={() => {
                        setViewDetails(null);
                        setLink(null);
                      }}
                    >
                      <Delete />
                    </IconButton>
                    <video controls width="100%" style={{ borderRadius: "8px", height: "200px" }}>
                      <source src={viewTest} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                ) : (
                  <DropzoneArea
                    acceptedFiles={["video/*"]}
                    filesLimit={1}
                    onChange={handleVideoChange}
                    dropzoneText="Drag and drop your video file here or click to select"
                  />
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography className={classes.label} style={{ marginBottom: "8px" }}>
                  Test Image <span style={{ color: "red" }}>*</span>
                </Typography>
                {testIMG ? (
                  <div className={classes.imageContainer} style={{ position: "relative" }}>
                    <IconButton
                      className={classes.deleteBTN}
                      onClick={() => {
                        setTestIMG(null);
                        setProfileImage("");
                      }}
                    >
                      <Delete />
                    </IconButton>
                    <img 
                      src={testIMG} 
                      alt="Test Image" 
                      style={{ 
                        width: "100%", 
                        height: "200px", 
                        objectFit: "cover",
                        borderRadius: "8px"
                      }} 
                    />
                  </div>
                ) : (
                  <Box className={testIMG == "" ? classes.colorbox : classes.colorbox1}>
                    <DropzoneArea
                      classes={classes.DropzoneArea}
                      acceptedFiles={["image/*"]}
                      maxFileSize={5000000}
                      filesLimit={1}
                      onDelete={() => {
                        setTestIMG("");
                        setProfileImage("");
                      }}
                      onDrop={handleDrop}
                      dropzoneText="Drag and drop your Image file here or click to select"
                    />
                  </Box>
                )}
              </Grid>
            </Grid>
            
            <div className={classes.uploadButtonContainer}>
              {loader ? (
                <CircularProgress />
              ) : (
                <>
                  {profileImage === "" || link === null ? (
                    <Button
                      onClick={() => {
                        if (viewTest) AddVideoHandler();
                        if (testIMG) uploadIMG();
                      }}
                      className={classes.btn}
                      variant="contained"
                    >
                      Upload New Files
                    </Button>
                  ) : (
                    <Typography className={classes.uploadedStatus}>
                      ✓ Files Uploaded Successfully
                    </Typography>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Time Configuration Section */}
          <div className={classes.formSection}>
            <Typography className={classes.sectionTitle}>Time Configuration</Typography>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <label className={classes.label}>
                  Incubation Time <span style={{ color: "red" }}>*</span>
                </label>
                <FormControl
                  variant="outlined"
                  fullWidth
                  className={classes.select}
                >
                  <Select
                    value={formData.incubation}
                    onChange={handleChange}
                    displayEmpty
                    inputProps={{
                      name: "incubation",
                      id: "incubation-select",
                    }}
                  >
                    <MenuItem value="">Select Incubation Time</MenuItem>
                    {Array.from({ length: 60 }, (_, index) => (
                      <MenuItem key={index + 1} value={index + 1}>
                        {index + 1}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormHelperText error className={classes.date}>
                  {/* {errors.incubation} */}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} md={6}>
                <label className={classes.label}>
                  Incubation Time Type <span style={{ color: "red" }}>*</span>
                </label>
                <FormControl
                  variant="outlined"
                  fullWidth
                  className={classes.select}
                >
                  <Select
                    margin="dense"
                    name="incubation"
                    value={incubationType}
                    onChange={(e) => setIncubationType(e.target.value)}
                    defaultValue="Select Incubation Time"
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                  >
                    <MenuItem value="SEC">Seconds</MenuItem>
                    <MenuItem value="MIN">Minutes</MenuItem>
                    <MenuItem value="HRS">Hours</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={6}>
                <label className={classes.label}>
                  Expiration Time <span style={{ color: "red" }}>*</span>
                </label>
                <FormControl
                  variant="outlined"
                  fullWidth
                  className={classes.select}
                >
                  <Select
                    value={formData.expirationTime}
                    onChange={handleChange}
                    displayEmpty
                    inputProps={{
                      name: "expirationTime",
                      id: "expirationTime-select",
                    }}
                  >
                    <MenuItem value="">Select Expiration Time</MenuItem>
                    {Array.from({ length: 60 }, (_, index) => (
                      <MenuItem key={index + 1} value={index + 1}>
                        {index + 1}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormHelperText error className={classes.date}>
                  {/* {errors.expirationTime} */}
                </FormHelperText>
              </Grid>

              <Grid item xs={12} md={6}>
                <label className={classes.label}>
                  Expiration Time Type <span style={{ color: "red" }}>*</span>
                </label>
                <FormControl
                  variant="outlined"
                  fullWidth
                  className={classes.select}
                >
                  <Select
                    margin="dense"
                    name="incubation"
                    value={expirationType}
                    onChange={(e) => setExpirationType(e.target.value)}
                    defaultValue="Select Incubation Time"
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                  >
                    <MenuItem value="SEC">Seconds</MenuItem>
                    <MenuItem value="MIN">Minutes</MenuItem>
                    <MenuItem value="HRS">Hours</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </div>
          {/* Unit Section */}
          <div className={classes.formSection}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <label className={classes.label}>
                  Unit <span style={{ color: "red" }}>*</span>
                </label>
                <TextField
                  placeholder="Enter unit"
                  type="text"
                  variant="outlined"
                  fullWidth
                  id="unit"
                  size="small"
                  inputProps={{ maxLength: 255 }}
                  name="unit"
                  onChange={(e) => handleChange(e)}
                  value={formData.unit}
                  className={classes.TextBox}
                />
                <FormHelperText error className={classes.date}>
                  {/* {errors.unit} */}
                </FormHelperText>
              </Grid>
            </Grid>
          </div>

          {/* Expected Test Result Section */}
          <div className={classes.resultSection}>
            <Typography className={classes.sectionTitle}>Expected Test Result Details</Typography>
            <Grid container spacing={3} style={{ marginTop: "16px" }}>
              {additionalResultFields?.map((value, index) => {
                return (
                  <Grid
                    container
                    spacing={3}
                    key={`result-field-${index}`}
                    style={{ marginBottom: "16px" }}
                  >
                    <Grid item xs={12} md={5}>
                      <label className={classes.label}>
                        Accepted Test Result Value
                      </label>
                      <TextField
                        placeholder="Enter result value"
                        type="text"
                        variant="outlined"
                        fullWidth
                        id={`acceptedResultValue-${index}`}
                        size="small"
                        inputProps={{ maxLength: 255 }}
                        name={`acceptedResultValue-${index}`}
                        value={value.resultValue}
                        onChange={(event) =>
                          handleChange1(event, index, "result")
                        }
                        className={classes.TextBox}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <label className={classes.label}>
                        Color Code <span style={{ color: "red" }}>*</span>
                      </label>
                      <TextField
                        placeholder="Enter color code (e.g., #FF0000)"
                        type="text"
                        variant="outlined"
                        fullWidth
                        id={`resultColorCode-${index}`}
                        size="small"
                        inputProps={{ maxLength: 7 }}
                        name={`resultColorCode-${index}`}
                        value={value.colorCode}
                        onChange={(event) =>
                          handleChange1(event, index, "color")
                        }
                        className={classes.TextBox}
                      />
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </div>

          {/* Action Buttons */}
          <div className={classes.buttonContainer}>
            <Button
              className={classes.btn}
              variant="outlined"
              onClick={() => history.goBack()}
              style={{
                background: "transparent",
                color: "#6c757d",
                border: "2px solid #6c757d",
                "&:hover": {
                  background: "#6c757d",
                  color: "white",
                }
              }}
            >
              Cancel
            </Button>
            <Button
              className={classes.btn}
              variant="contained"
              onClick={() => updateTestDetails()}
            >
              Update Test
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default UpdateTest;
